import { useMemo } from 'react';
import { convertTel } from 'utils/convertTelephone';
import { TelegramSIcon, WhatsAppSIco } from 'assets/icons';

export const useInformationPresenter = (info) => {
  const whatsupUrl = `https://wa.me/${info?.phoneNumber}`;
  const telegramUrl = `https://t.me/+${info?.phoneNumber}`;
  const isShowWhatsupButton = Boolean(info?.hasWhatsapp);
  const isShowTelegramButton = Boolean(info?.hasTelegram);

  const title = info.name;
  const phone = convertTel(info?.phoneNumber) || '-';
  const email = info?.email || '-';
  const subtitle = info.subtitle;
  const imgId = info.avatarId;

  const messengerButtons = useMemo(
    () =>
      [
        {
          show: isShowWhatsupButton,
          url: whatsupUrl,
          Icon: WhatsAppSIco,
          label: 'WhatsApp',
          dataTest: 'whatsAppButton',
        },
        {
          show: isShowTelegramButton,
          url: telegramUrl,
          Icon: TelegramSIcon,
          label: 'Telegram',
          dataTest: 'telegramButton',
        },
      ].filter((button) => button.show),
    [isShowWhatsupButton, isShowTelegramButton, whatsupUrl, telegramUrl]
  );

  return {
    messengerButtons,
    title,
    subtitle,
    phone,
    email,
    imgId,
  };
};
